<app-layout-page>
  <app-layout-header></app-layout-header>

  <app-layout-content class="content-loading">
    <h3 trans="account.landing.options.2fa.loading"></h3>

    <div class="progress">
      <img class="spinner" alt="" src="/assets/image/graphic/loading-spinner.svg">
    </div>
  </app-layout-content>

</app-layout-page>
